import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'yo',
    fullName: 'Yoruba',
    nativeName: 'Èdè Yorùbá',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ohun Kayeefi Nbọ",
    landing_subtitle: "ArgVoid jẹ ohun elo ati ile iṣere idagbasoke ere. Duro aifwy, awọn nkan tuntun n bọ laipẹ!",
    select_language: "Yan Ede",
    search_placeholder: "Wa awọn ede...",
    terms_title: "Awọn ofin ti Service",
    policy_title: "Asiri Afihan",
    cookies_title: "kukisi Afihan",
    terms_content: `
        <strong>1. Gbigba Awọn ofin</strong><br>
        Nipa iraye si ArgVoid, Awọn ofin Iṣẹ wọnyi jẹ itẹwọgba. Ti a ko ba gba awọn ofin wọnyi, iṣẹ naa ko yẹ ki o lo.<br><br>

        <strong>2. Platform Usage</strong><br>
        ArgVoid ati awọn ohun elo rẹ ti pese “bi o ti jẹ” fun alaye ati awọn idi ẹda. Iṣẹ naa gbọdọ ṣee lo fun awọn idi ti o tọ nikan.<br><br>

        <strong>3. Ewọ Conduct</strong><br>
        Lilo awọn ailagbara ojula, spamming, tabi igbiyanju iraye si laigba aṣẹ si awọn amayederun jẹ eewọ patapata.<br><br>

        <strong>4. Disclaimer</strong><br>
        Syeed ati awọn iṣẹ le jẹ atunṣe nigbakugba laisi akiyesi. Ko si atilẹyin ọja ti a pese nipa akoko ipari tabi wiwa iṣẹ naa.
    `,
    policy_content: `
        <strong>1. Gbigba Alaye</strong><br>
        Syeed ko nilo ijẹrisi olumulo tabi ṣiṣẹda akọọlẹ ni akoko yii. Ko si alaye idamo ti ara ẹni (gẹgẹbi awọn orukọ tabi adirẹsi imeeli) ti a gba ni itara lati ọdọ awọn alejo.<br><br>

        <strong>2. Lilo Data</strong><br>
        Ipilẹ, awọn atupale ailorukọ le jẹ gbigba lati loye ijabọ aaye ati ilọsiwaju awọn ohun elo naa. Data yii ko ni asopọ si awọn idanimọ olumulo kọọkan.<br><br>

        <strong>3. Ẹni-kẹta Services</strong><br>
        Awọn olupese ẹnikẹta le ṣee lo fun alejo gbigba ati awọn iṣẹ atupale. Awọn iṣe aṣiri ti awọn olupese oniwun wọnyi ṣe akoso data ailorukọ ti a ṣe ilana lori awọn amayederun wọn.<br><br>

        <strong>4. Data Security</strong><br>
        Awọn igbese aabo ti o ni imọran ni imuse lati daabobo pẹpẹ. Sibẹsibẹ, ko si ọna gbigbe lori Intanẹẹti ti o ni aabo patapata.<br><br>
    `,
    cookies_content: `
        <strong>1. Kini Awọn kuki ati Ibi ipamọ agbegbe?</strong><br>
        Awọn kuki ati ibi ipamọ agbegbe aṣawakiri jẹ awọn faili data kekere ti o fipamọ sori ẹrọ lati ranti awọn ayanfẹ iṣeto ni gbogbo awọn abẹwo.<br><br>

        <strong>2. Lilo Purpose</strong><br>
        Ibi ipamọ Agbegbe aṣawakiri jẹ lilo muna lati fi awọn eto atunto pamọ, bii:<br>
        - Awọn ayanfẹ ede<br>
        - Iṣeto ni wiwo olumulo (fun apẹẹrẹ, akọkọ tabi awọn eto akori) <br>
        - Ohun elo igba diẹ cache<br><br>

        <strong>3. Ko si Tracking</strong><br>
        Awọn kuki ati ibi ipamọ agbegbe ko lo fun ipolowo tabi awọn idi ipasẹ ẹnikẹta. Gbogbo data ti o ti fipamọ jẹ muna fun iṣẹ-ṣiṣe pataki ti Syeed.<br><br>

        <strong>4. Control</strong><br>
        Awọn data aṣawakiri le jẹ imukuro nigbakugba nipasẹ awọn eto ẹrọ aṣawakiri, eyiti yoo tun awọn atunto agbegbe eyikeyi.
    `,
    cookie_consent_text: "A lo awọn kuki ipilẹ lati rii daju pe oju opo wẹẹbu n ṣiṣẹ ni deede, gẹgẹbi mimu ki igba rẹ ṣiṣẹ, fifipamọ ayanfẹ ede rẹ, ati awọn atunto aṣa miiran.",
    read_policy: "Ka kukisi Afihan",
    support_title: "Olubasọrọ Support",
    support_subject_label: "Koko-ọrọ",
    support_message_label: "Ifiranṣẹ",
    support_submit_button: "Firanṣẹ Ifiranṣẹ",
    support_hint: "Akiyesi: Eyi yoo ṣii ohun elo imeeli aiyipada rẹ lati fi ifiranṣẹ ranṣẹ.",
    support_success_msg: "Nsii ohun elo imeeli rẹ...",
    support_error_msg: "Kuna lati fi ifiranṣẹ ranṣẹ. Jọwọ gbiyanju lẹẹkansi nigbamii.",
    explorer_title: "Explorer",
    history_title: "Itan",
    animation_title: "Idaraya",
    config_title: "Iṣeto ni",
    tool_mouse: "Yan (Ctrl+M)",
    tool_brush: "Fẹlẹ (Ctrl+B)",
    tool_brush_mode: "Ipo Yipada (Dile/Ko o)",
    tool_eraser: "Apanirun (Ctrl+E)",
    tool_brush_size: "Ṣatunṣe Iwọn Fẹlẹ",
    tool_bucket: "Fọwọsi (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Akoj (Ctrl+Shift+B)",
    tool_rotate: "Yipada (Ctrl+Shift+R)",
    tool_flip_h: "Yipada H (Ctrl+Shift+H)",
    tool_flip_v: "Yipada V (Ctrl+Shift+V)",
    tool_transpose: "Yipada (Ctrl+Shift+T)",
    label_width: "Ìbú",
    label_height: "Giga",
    label_frames: "Nọmba ti Awọn fireemu",
    label_animation: "Aworan ara",
    label_background_color: "Awọ abẹlẹ",
    label_interval: "Àárín",
    tool_anim_config: "Animation iṣeto ni",
    label_new_width: "Iwọn Tuntun",
    label_new_height: "Giga Tuntun",
    label_apply: "Waye",
    label_colors: "Awọn awọ",
    label_size: "Iwọn",
    label_tolerance: "Ifarada",
    val_horizontal: "Petele",
    val_vertical: "Inaro",
    val_sequence: "Ọkọọkan",
    val_bounce: "Bounce",
    val_random: "Laileto",
    val_solid: "ri to",
    val_clear: "Ko o",
    action_add_sheet: "Titun Dì",
    action_import: "gbe wọle",
    action_export: "okeere",
    action_sort_projects: "Too",
    sort_date_old: "Atijọ julọ First",
    sort_date_new: "Hunting First",
    sort_name_az: "Orukọ (A-Z)",
    sort_name_za: "Orukọ (Z-A)",
    action_new_sprite: "Sprite Tuntun",
    action_new_project: "New Project",
    modal_save_all_title: "Fi Gbogbo Ayipada",
    modal_save_all_desc: "Yan awọn ohun-ini lati fipamọ:",
    modal_save_selected: "Fipamọ ti a yan",
    action_saved: "Ti fipamọ",
    modal_create_sprite_title: "Ṣẹda New Sprite",
    modal_create_project_title: "Ṣẹda New Project",
    modal_add_sheet_title: "Fi Tuntun Dì",
    modal_rename_sheet_title: "Fun lorukọ mii Sheet",
    modal_rename_sprite_title: "Lorukọmii Sprite",
    modal_delete_sprite_title: "Pa Sprite",
    modal_delete_project_title: "Pa Project",
    modal_delete_sheet_title: "Paarẹ dì",
    placeholder_sprite_name: "Oruko",
    placeholder_project_name: "Oruko",
    placeholder_sheet_name: "Oruko",
    placeholder_new_name: "Oruko Tuntun",
    action_create: "Ṣẹda",
    action_add: "Fi kun",
    action_rename: "Fun lorukọ mii",
    action_duplicate: "Ṣe pidánpidán",
    action_delete: "Paarẹ",
    action_cancel: "Fagilee",
    confirm_delete_sprite: "Ṣe o da ọ loju pe o fẹ paarẹ sprite yii bi?",
    confirm_delete_project: "Ṣe o da ọ loju pe o fẹ pa iṣẹ akanṣe yii rẹ bi? Gbogbo awọn sprites yoo yọ kuro.",
    confirm_delete_sheet: "Ṣe o da ọ loju pe o fẹ paarẹ iwe yii bi?",
    err_select_sprite: "Jọwọ yan sprite ni akọkọ.",
    err_select_project: "Jọwọ yan ise agbese kan ni akọkọ.",
    err_name_empty: "Orukọ ko le jẹ ofo.",
    err_sprite_exists: "Sprite pẹlu orukọ yẹn ti wa tẹlẹ.",
    err_project_exists: "Iṣẹ akanṣe pẹlu orukọ yẹn ti wa tẹlẹ.",
    err_no_content: "Ko si akoonu lati fipamọ.",
    err_no_changes: "Ko si ayipada lati fipamọ.",
    err_delete_last_sheet: "Ko le pa iwe ti o kẹhin rẹ.",
    err_extract_frames: "Ko le jade eyikeyi awọn fireemu.",
    err_indexeddb: "Kuna lati fipamọ ni agbegbe. Aṣàwákiri rẹ le ma ṣe atilẹyin IndexedDB.",
    msg_upload_success: "Ṣe ikojọpọ: {0}",
    msg_upload_failed: "Ìrùsókè kùnà: {0}",
    msg_save_success: "Fipamọ aṣeyọri.",
    msg_saving: "Nfipamọ...",
    msg_multi_save_result: "Ti fipamọ awọn ohun-ini {0}. {1} ikuna.",
    menu_title: "Akojọ aṣyn",
    menu_save: "Fipamọ",
    menu_save_all: "Fi Gbogbo wa pamọ",
    menu_support: "Olubasọrọ Support",
    label_local_storage: "Ibi ipamọ agbegbe",
    label_sign_in: "Wọle",
    modal_export_title: "okeere Sprite",
    label_filename: "Orukọ faili",
    label_format: "Ọna kika",
    action_export_confirm: "okeere",
};

export default translations;
